import { Injectable } from '@angular/core';
import {
  InsufficientMilesIconType,
  PopupSettingService,
} from '@rd/popup/services/popup-setting/popup-setting.service';

@Injectable({
  providedIn: 'root',
})
export class StarPopupSettingService extends PopupSettingService {
  // AuthSecureRouteDialog settings
  shouldRenderRegisterLink = true;
  shouldRenderLoginButton = true;
  insufficientMilesIconType: InsufficientMilesIconType = 'warning';
}
